"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appGen = void 0;
var react_1 = __importDefault(require("react"));
var connected_react_router_1 = require("connected-react-router");
function appGen(Route, history) {
    return function () { return (react_1.default.createElement(connected_react_router_1.ConnectedRouter, { history: history },
        react_1.default.createElement(Route, null))); };
}
exports.appGen = appGen;
